var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail"},[_vm._v(" 这是一个详情页"+_vm._s(_vm.id)+" "),_c('br'),_vm._v(" 随机数："+_vm._s(Math.floor(Math.random()*10000))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }